import { render } from "./CampaignsCreate.vue?vue&type=template&id=018265eb&scoped=true"
import script from "./CampaignsCreate.vue?vue&type=script&lang=js"
export * from "./CampaignsCreate.vue?vue&type=script&lang=js"

import "./CampaignsCreate.vue?vue&type=style&index=0&id=018265eb&lang=scss&scoped=true"
import "./CampaignsCreate.vue?vue&type=style&index=1&id=018265eb&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018265eb"]])

export default __exports__